export const routerPlugin = ({ app, store }) => {
  if (app.config.globalProperties.$router) {
    store.$router = app.config.globalProperties.$router;
  }
};
